module.exports = __webpack_public_path__ + "img/training-icon-01.f2f2b274.gif";